import { render, staticRenderFns } from "./scrotalShedWise.vue?vue&type=template&id=1d3352cb&scoped=true&"
import script from "./scrotalShedWise.vue?vue&type=script&lang=js&"
export * from "./scrotalShedWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3352cb",
  null
  
)

export default component.exports